import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbModal, NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';
import { Task } from '../../../../api/models/task';
import { AddressCreationComponent } from '../../../address-creation/address-creation.component';
import { Worksheet } from '../../../../api/models/worksheet';
import { MarketService } from '../../../../api/services/market.service';
import { Address } from '../../../../api/models/address';
import { CutCableTableComponent } from '../../../cut-cable-modal/cut-cable-table/cut-cable-table.component';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { ProjectService } from '../../../../api/services/project.services';
import { ApprovalService } from '../../../../api/services/approval.service';
import { BomLine } from '../../../../api/models/bom-line';
import { ApproverReasonComponent } from '../../../comments/approver-reason/approver-reason.component';
import { CommentsAdapterService } from '../../../comments/comments-adapter.service';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { ProductAliasService } from '../../../../api/services/product-alias.service';
import { debounceTime, distinctUntilChanged, switchMap, catchError, finalize } from 'rxjs/operators';
import { AuthService } from '../../../../api/services/auth.service';
import { RoleRequest } from '../../../../api/models/role-assignment-map';

export class BtnModel {
  name: string;
  action: any;
  class: string;
  disable: any;
}

export class ProgrammingRequirement {
  requirement: string;
  qty: number;

  constructor(req?: string, qty?: number) {
    this.requirement = req || '';
    this.qty = qty || 1;
  }
}

@Component({
  selector: 'app-task-confirmation-dialog',
  templateUrl: './task-confirmation-dialog.component.html',
  styleUrls: ['./task-confirmation-dialog.component.scss'],
  providers: [CommentsAdapterService]
})

export class TaskConfirmationDialogComponent implements OnInit {

  @Input() task: Task;

  taskInfoError = false;
  errorMessage;
  title = '';
  buttons: BtnModel[] = [];
  addresses: Address[] = [];
  addressSelected = '';
  secondaryAddressSelected = '';
  worksheet: Worksheet;
  line: BomLine;

  requirementsForm: FormGroup;
  requirementsFormArray: FormArray;

  needByDate: any;
  productMPN: string;
  loading: boolean = false;
  loadAddress: boolean = false;

  checkFormValidFlag: boolean;
  isTesscoAdmin: boolean;

  @ViewChild(CutCableTableComponent) cutsTable: CutCableTableComponent;

  constructor(
    private activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private marketService: MarketService,
    private formBuilder: FormBuilder,
    private projectService: ProjectService,
    private approvalService: ApprovalService,
    private productAliasService: ProductAliasService,
    private commentsAdapterService: CommentsAdapterService,
    private authService: AuthService
  ) { }

  ngOnInit() {
    this.errorMessage = undefined;
    if (this.task.worksheetID) 
    {
      this.projectService.getWorksheet(this.task.worksheetID).subscribe(worksheet => {
        this.worksheet = worksheet;
        if (this.task.bomLineID) {
          this.projectService.getBomLines(this.worksheet.bomId).subscribe(lines => {
            this.line = lines.find(line => line.id === this.task.bomLineID);
            if (this.task.taskType === 'CABLE CUT') {
              const sku = this.line.partNumber;
              if (sku && sku.length > 0) {
                this.productAliasService.getProductMinInfo([sku], localStorage.getItem("marketAccountNo")).subscribe(products => {
                  this.productMPN = products[0].manufacturerPartNumber;
                });
              }
            }
          });
        }
      this.getTaskInformation(this.task);
        this.authService.getUserRoles(new RoleRequest('ADMIN_TESSCO', null)).subscribe(roles => {
          this.isTesscoAdmin = roles.getRoleMap('ADMIN_TESSCO');
        });
      });
    }
  }

  getTaskInformation(task: Task) 
  {
    switch (task.taskType) {
      case 'APPROVAL':
        this.title = 'Approve/Deny Order';
        this.buttons = [{ name: 'Deny', action: this.deny, class: 'btn-danger', disable: this.getButtonDisableFalse },
        { name: 'Approve', action: this.approve, class: 'btn-primary', disable: this.getButtonDisableFalse }];
        break;
      case 'CABLE CUT':
        this.title = 'Confirm Cable Cuts';
        this.buttons = [{ name: 'Confirm', action: this.confirmCuts, class: 'btn-tessco-primary', disable: this.getCheckFormValid }];
        break;
      case 'REQUESTED DELIVERY DATE':
        this.title = 'Select Need By Date';
        this.buttons = [{ name: 'Save', action: this.confirmNeedByDate, class: 'btn-tessco-primary', disable: this.getButtonDisableFalse }];
        break;
      case 'PROGRAMMABLE PRODUCT':
        this.title = 'Confirm Programming Requirements';
        this.buttons = [{ name: 'Confirm', action: () => this.activeModal.close(), class: 'btn-tessco-primary', disable: this.getButtonDisableFalse }];
        this.requirementsForm = this.formBuilder.group({
          requirements: this.formBuilder.array(this.mapAllRequirementsForFormGroupList([]))
        });
        this.requirementsFormArray = this.requirementsForm.get('requirements') as FormArray;
        break;
      case 'ADDRESS VERIFICATION':
        this.title = 'Select Address';
        this.buttons = [{ name: 'Save', action: this.confirmAddress, class: 'btn-tessco-primary', disable: this.getButtonDisableTrue }];
        this.marketService.getAddresses(this.worksheet.project.marketId).subscribe(addr => {
          this.addresses = addr;
        });
        break;
      default:
        this.taskInfoError = true;
        break;
    }
  }

  approve = () => {
    const modalRef = this.modalService.open(ApproverReasonComponent, {
      backdrop : 'static',
      keyboard : false
    });
    modalRef.componentInstance.type = 'Approved';
    const approvalId = this.worksheet.approvalId;
    modalRef.result.then(approvalReasonResponse => {
      this.loading = true;
      this.approvalService.approveV2(approvalId, approvalReasonResponse.reason).subscribe(() => {
        this.worksheet.approvalStatus = 'APPROVED';
        if (approvalReasonResponse.reason) {
          this.commentsAdapterService.getCommentsTree(`WORKSHEET~${this.worksheet.bomId}`, this.isTesscoAdmin).subscribe(comments => {
            this.commentsAdapterService.createComment(approvalReasonResponse.reason, false, null, [], 'Approved').subscribe(comment => {
              this.loading = false;
              this.activeModal.close(true);
            });
          });
        }else{
          this.loading = false;
          this.activeModal.close(true);
        }
      }, error => {
        this.loading = false;
        this.errorMessage = error.error.message;
      });
    }).catch(() => {
      this.loading = false;
      this.activeModal.close();
    });
  }

  deny = () => {
    const modalRef = this.modalService.open(ApproverReasonComponent, {
      backdrop : 'static',
      keyboard : false
    });
    modalRef.componentInstance.type = 'Declined';
    const approvalId = this.worksheet.approvalId;
    modalRef.result.then(approvalReasonResponse => {
      this.loading = true;
      this.approvalService.deny(approvalId, approvalReasonResponse.reason).subscribe(() => {
        this.worksheet.approvalStatus = 'DENIED';
        if (approvalReasonResponse.reason) {
          this.commentsAdapterService.getCommentsTree(`WORKSHEET~${this.worksheet.bomId}`, this.isTesscoAdmin).subscribe(comments => {
            this.commentsAdapterService.createComment(approvalReasonResponse.reason, false, null, [], 'Declined').subscribe(comment => {
              this.loading = false;
              this.activeModal.close(true);
            });
          });
        }else{
          this.loading = false;
          this.activeModal.close(true);
        }
      }, error => {
        this.loading = false;
        this.errorMessage = error.error.message;
      });
    }).catch(() => {
      this.loading = false;
      this.activeModal.close();
    });
  }

  confirmNeedByDate = () => {
    this.worksheet.requestedDeliveryDate = this.needByDate.toISOString();
    this.worksheet.confirmedNeedByDate = true;
    this.worksheet.taskType = this.task.taskType;
    this.projectService.updateWorksheet(this.task.worksheetID, this.worksheet).subscribe(worksheet => {
      if (worksheet.isQuoted && !worksheet.lastOrderTransactionId) {
        this.projectService.getQuote(worksheet.lastQuoteTransactionId).subscribe(quoteTransaction => {
          quoteTransaction.quoteInput.deliveryOptions.deliverByDate = this.needByDate.toISOString();
          quoteTransaction.quoteInput.orderOptions.requestedShipDate = this.needByDate.toISOString();
          this.projectService.updateDeliverByDate(worksheet.lastQuoteTransactionId, quoteTransaction.quoteInput).subscribe(() => {
            this.activeModal.close(true);
          });
        });
      } else {
        this.activeModal.close(true);
      }
    }, error => {
      this.activeModal.close(true);
    });
  }

  confirmCuts = () => {
    this.cutsTable.addAndDeleteCableCuts(true);
  }

  confirmAddress = () => {
    this.worksheet.shipToAddressId = this.addressSelected;
    this.worksheet.secondaryAddressId = this.secondaryAddressSelected;
    this.worksheet.confirmedShipToAddressId = true;
    this.worksheet.taskType = this.task.taskType;
    this.projectService.updateWorksheet(this.task.worksheetID, this.worksheet).subscribe(() => {
      this.activeModal.close(true);
    });
  }

  selectSecondaryAddress(secondaryAddressId: string) {
    this.secondaryAddressSelected = secondaryAddressId;
  }

  format(date: string) {
    this.needByDate = new Date(date);
  }

  addAddress() {
    const modalRef = this.modalService.open(AddressCreationComponent, {
      backdrop: 'static',
      keyboard: false
    });

    modalRef.result
      .then(newAddress => {
        this.activeModal.close();

      })
      .catch(() => { });
  }

  setAddress(id: string) {
    if (id === '-1') {
      this.addAddress();
    } else {
      this.addressSelected = id;
    }
  }

  needSecondAddress() {
    if (this.addressSelected) {
      return this.needBulk() || this.needParcel();
    } else {
      return false;
    }
  }

  needBulk() {
    const addr = this.addresses.find(a => a.id === this.addressSelected);
    return addr ? !addr.acceptBulk : false;
  }

  needParcel() {
    const addr = this.addresses.find(a => a.id === this.addressSelected);
    return addr ? !addr.acceptParcel : false;
  }

  getMessageSecondaryAddress() {
    if (this.needBulk() && this.needParcel()) {
      return 'A secondary address is required to support shipments that will accept bulk and parcel shipments';
    } else if (this.needBulk()) {
      return 'A secondary address is required to support bulk shipments';
    } else if (this.needParcel()) {
      return 'A secondary address is required to support parcel shipments';
    }
  }

  getAddressPB() {
    if (this.needBulk() && this.needParcel()) {
      return this.addresses.filter(a => a.acceptBulk && a.acceptParcel);
    } else if (this.needBulk()) {
      return this.addresses.filter(a => a.acceptBulk);
    } else {
      return this.addresses.filter(a => a.acceptParcel);
    }
  }


  mapRequirementToFormGroup(requirement: ProgrammingRequirement) {
    return this.formBuilder.group({
      requirement: requirement.requirement,
      qty: requirement.qty
    });
  }

  mapAllRequirementsForFormGroupList(requirements: ProgrammingRequirement[]): FormGroup[] {
    const formGroupList: FormGroup[] = [];

    if (requirements.length === 0) {
      formGroupList.push(this.mapRequirementToFormGroup(new ProgrammingRequirement()));
    }

    requirements.forEach(req => {
      formGroupList.push(this.mapRequirementToFormGroup(req));
    });
    return formGroupList;
  }

  addRequirement(): void {
    this.requirementsFormArray.push(this.mapRequirementToFormGroup(new ProgrammingRequirement()));
    this.requirementsFormArray.markAsDirty();
  }

  deleteRequirement(index: number) {
    this.requirementsFormArray.removeAt(index);
    this.requirementsFormArray.markAsDirty();
  }

  addressSearch = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap(term => {
        if (term && term.length > 0) {
          this.loadAddress = true;
        }
        return !term ? of([]) : this.marketService.findAddressesByText(this.worksheet.project.marketId, term).pipe(
          catchError(err => {
            return of([]);
          }),
          finalize(() => {
            this.loadAddress = false;
          })
        );
      })
    );

  addressFormatter = (entity: Address) => {
    return entity.id ? `${entity.line1}, ${entity.city}, ${entity.state}` : '';
  }

  onAddressSelected($event: NgbTypeaheadSelectItemEvent, alias: HTMLInputElement) {
    if (!$event.item.id) {
      $event.item.alias = alias.value;
      alias.value = null;
      $event.preventDefault();
    }
    this.addressSelected = $event.item.id;
    if(this.task.taskType == 'ADDRESS VERIFICATION' && this.addressSelected){
      this.buttons[0].disable = this.getButtonDisableFalse;
    }
  }

  checkFormValid(formValid: boolean) {
    this.checkFormValidFlag = formValid;
  }

  getCheckFormValid = () => {
    return !this.checkFormValidFlag;
  }

  getButtonDisableTrue = () => {
    return true;
  }

  getButtonDisableFalse = () => {
    return false;
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/dashboard-my-oasis/project-order-summary/task-confirmation-dialog/task-confirmation-dialog.component.ts